import { LOGGER } from '@cicero/data/utils'

/**
 * CacheService maintains a very basic store of keys, and how long to cache them for
 * You can then run performUnlessCached with a callback. The callback is only
 * executed if no valid cache entry exists.
 */
export class CacheService {
  protected cache = new Map<string, number>()
  get size() { return this.cache.size }

  performUnlessCached(key: string, action: () => any, cacheFor: number) {
    const cacheHit = this.cache.get(key)
    const now = Date.now()
    if (cacheHit) {
      // We ran this at some point, let's see if it is still valid
      if (cacheHit > now) {
        LOGGER.debug('[CACHE_HIT]', key)
        return
      } else {
        // Cache expired, rerun
      }
    }

    action() // TODO How to handle if this fails? Need to invalidate the cache
    this.addToCache(key, cacheFor)
  }

  addToCache(key: string, cacheFor: number) {
    const cacheHit = this.cache.get(key)
    const cacheUntil = Date.now() + cacheFor
    if (cacheHit === undefined || cacheUntil > cacheHit) {
      this.cache.set(key, cacheUntil)
    }
  }

  clear(match?: RegExp|string) {
    if (match === undefined) { this.cache.clear() }
    Array.from(this.cache.keys())
      .filter(key => typeof match === 'string' ? key === match : match?.test(key))
      .forEach(key => this.cache.delete(key))
  }
}
